import { useState, useEffect } from 'react'

export function useAuth() {
  const [state, setState] = useState({ user: null, loading: true, authenticated: false })

  useEffect(() => {
    fetch('/auth/me')
      .then(r => r.json())
      .then(data => setState({
        user: data.user ?? null,
        loading: false,
        authenticated: data.authenticated ?? false,
      }))
      .catch(() => setState({ user: null, loading: false, authenticated: false }))
  }, [])

  return state
}
